import dayjs from "dayjs";

// Local-time serialization for pickup dates. Date.prototype.toISOString()
// converts to UTC, which shifts the calendar date for any user whose local
// time is within the UTC offset of midnight (e.g. 00:00-01:00 during BST) —
// pickups then get booked for the previous day and the carrier rejects them.
export const toLocalIsoDateTime = (date: Date): string =>
  dayjs(date).format("YYYY-MM-DDTHH:mm:ss");
